import { useMutation } from '@apollo/client'

import { CreateReceivingDocumentLineItemDocument } from '@/graphql/purchase-plus/generated/createReceivingDocumentLineItem.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'

export default function useCreateReceivingDocumentLineItem() {
  const mutation = useMutation(CreateReceivingDocumentLineItemDocument, {
    context: {
      uri: PURCHASE_PLUS_GRAPHQL_API,
    },
  })

  return mutation
}
